import Component from '../abstracts/Component';

export default class PdpGalleryComponent extends Component {
  get SELECTORS() {
    return {
      thumbs: '[data-gallery-thumb]',
      slideVisible: '[data-gallery-main-img].on-view',
      slider: '[data-gallery-slider]',
      images: '[data-gallery-main-img]',
      slickMobileContainer: '[data-slick-mobile]',
      gallery: '[data-gallery]',
      galleryCloseBtn: '[data-gallery-close]',
      galleryThumbsBtn: '[data-gallery-zoom-thumb]',
      galleryZoomImg: '[data-gallery-zoom-img]',
    };
  }

  get CLASSNAMES() {
    return {
      slideVisible: 'on-view',
      galleryShow: 'show',
      activeThumb: 'active',
      loadingClass: 'loading',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.thumbs = this.$component.querySelectorAll(this.SELECTORS.thumbs);
    this.images = this.$component.querySelectorAll(this.SELECTORS.images);
    this.slider = this.$component.querySelector(this.SELECTORS.slider);
    this.currentSlide = this.$component.querySelector(
      this.SELECTORS.slideVisible
    );
    this.gallery = this.$component.querySelector(this.SELECTORS.gallery);
    this.closeBtn = this.$component.querySelector(
      this.SELECTORS.galleryCloseBtn
    );
    this.galleryZoomImg = this.$component.querySelector(
      this.SELECTORS.galleryZoomImg
    );
    this.galleryThumbsBtn = this.$component.querySelectorAll(
      this.SELECTORS.galleryThumbsBtn
    );
    this.slickMobileContainer = this.$component.querySelector(
      this.SELECTORS.slickMobileContainer
    );
    this.slickInstance = null;
  }

  isMobile() {
    let mq = window.matchMedia('(max-width:767px)');
    let isMobile = mq.matches;
    return isMobile;
  }

  thumbsHandler() {
    // loop
    for (let thumb of this.thumbs) {
      thumb.addEventListener('click', () => {
        let targetId = thumb.dataset.targetImgId;
        // remove visible class
        this.currentSlide.classList.remove(this.CLASSNAMES.slideVisible);
        // switch current slide
        this.currentSlide = document.getElementById(targetId);
        // add class to slide
        this.currentSlide.classList.add(this.CLASSNAMES.slideVisible);
        // remove thumb active class
        document
          .querySelector(
            this.SELECTORS.thumbs + '.' + this.CLASSNAMES.activeThumb
          )
          .classList.remove(this.CLASSNAMES.activeThumb);
        // add thumb active class
        thumb.classList.add(this.CLASSNAMES.activeThumb);
      });
    }
  }

  openMobileGallery(id) {
    // get target img
    let targetImg = this.$component.querySelector(`[data-gallery-img="${id}"]`);
    // show gallery
    this.gallery.classList.add(this.CLASSNAMES.galleryShow);
    // scroll until the image for the mobile
    targetImg.scrollIntoView();
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
  }

  updateDesktopGallery(el) {
    // global
    let ctx = this;
    // show desktop gallery
    if (!this.gallery.classList.contains(this.CLASSNAMES.galleryShow))
      this.gallery.classList.add(this.CLASSNAMES.galleryShow);
    // set the id
    let id = 'gallery_zoom_' + el.dataset.galleryZoomThumb;
    // i want the fade effect
    this.galleryZoomImg.classList.add(this.CLASSNAMES.loadingClass);
    // let's wait the css transition
    setTimeout(function() {
      // remove the active if present
      let activeImg = ctx.galleryZoomImg.querySelector('.active');
      if (activeImg != null) activeImg.classList.remove('active');
      // check if there is the div
      if (ctx.galleryZoomImg.querySelector('#' + id) != null) {
        // add selected active class
        ctx.galleryZoomImg.querySelector('#' + id).classList.add('active');
      } else {
        // create box image
        let imgBox = document.createElement('div');
        imgBox.classList.add('single-image');
        imgBox.classList.add('active');
        imgBox.setAttribute('id', id);
        // new image
        let myImg = document.createElement('img');
        myImg.setAttribute('src', el.dataset.galleryZoom);
        myImg.setAttribute('alt', el.dataset.galleryImgAlt);
        // append to box
        imgBox.append(myImg);
        // appending to div
        ctx.galleryZoomImg.append(imgBox);
      }
    }, 500);
    // show the active image
    setTimeout(function() {
      ctx.galleryZoomImg.classList.remove(ctx.CLASSNAMES.loadingClass);
    }, 1000);
  }

  updateActiveThumbs(btn) {
    // remove thumb active class
    document
      .querySelector(
        this.SELECTORS.galleryThumbsBtn + '.' + this.CLASSNAMES.activeThumb
      )
      .classList.remove(this.CLASSNAMES.activeThumb);
    // add thumb active class
    btn.classList.add(this.CLASSNAMES.activeThumb);
  }

  galleryHandler() {
    let scrollY;
    if (this.images.length) {
      this.images.forEach(image => {
        image.addEventListener('click', () => {
          // different behaviours
          if (this.isMobile()) {
            // mobile
            let imgId = image.id;
            this.openMobileGallery(imgId);
          } else {
            // open the gallery
            this.updateDesktopGallery(image);
          }
        });
      });
    }
    this.closeBtn.addEventListener('click', () => {
      this.gallery.classList.remove(this.CLASSNAMES.galleryShow);
      document.body.style.position = '';
      window.scrollTo(0, scrollY);
    });
    // gallery zoom thumb actions
    if (this.galleryThumbsBtn != null) {
      this.galleryThumbsBtn.forEach(btn => {
        btn.addEventListener('click', () => {
          // open the gallery
          this.updateDesktopGallery(btn);
          // update the thumbs
          this.updateActiveThumbs(btn);
        });
      });
    }
  }

  importSlick() {
    return new Promise((resolve, reject) => {
      this.moduleLoader.loadCarouselAndExecute(
        module => {
          resolve(module);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  toggleSlickMobile(bool = true) {
    if (!bool) {
      if (this.slickInstance !== null){
        this.slickInstance.unslick();
        this.slickInstance = null;
      }
      return;
    }
    this.importSlick()
      .then(() => {
        this.instanceMobileSlick();
      })
      .catch(err => {
        console.log(err);
      });
  }

  instanceMobileSlick() {
    if (!this.slickMobileContainer) return;
    this.log('PDP Gallery Mobile slick ON');
    const opts = {
      dots: true,
      arrows: false,
      autoplay: false,
      centerMode: false,
      slidesToScroll: 1,
      slidesToShow: 1,
      infinite: true,
      variableWidth: false,
      responsive: [],
    };
    this.slickInstance = $(this.slickMobileContainer).slick(opts);
  }

  render() {
    this.log('Rendering...');
    this.thumbsHandler();
    this.galleryHandler();
    this.toggleSlickMobile(this.isMobile());
  }
}
